/**
 * Enum for Profile Menu types.
 */
export enum ProfileMenuType {
  Transactions = 'transactions',
  Reoccurring = 'reoccurring',
  Payment = 'payment',
  Profile = 'profile',
}
